import CardViewIcon from '@assets/icons/card-view.svg?react'
import TableViewIcon from '@assets/icons/table-view.svg?react'
import cn from 'classnames'
import ReactTooltip from 'react-tooltip'

import './ListViewToggle.scss'

export const VIEW_MODE = Object.freeze({
  DETAIL: 'detail',
  TABLE: 'table'
} as const)

export type ViewMode = (typeof VIEW_MODE)[keyof typeof VIEW_MODE]

type ListViewToggleProps = {
  mode: ViewMode
  onChange: (mode: ViewMode) => void
  tableLabel: string
  detailLabel: string
  groupLabel: string
  tooltipId: string
  testIdPrefix?: string
}

export const ListViewToggle = ({
  mode,
  onChange,
  tableLabel,
  detailLabel,
  groupLabel,
  tooltipId,
  testIdPrefix
}: ListViewToggleProps) => {
  return (
    <div
      className={cn('list-view-toggle', `mode-${mode}`)}
      role='group'
      aria-label={groupLabel}
      data-test={testIdPrefix}
    >
      <span className='list-view-toggle-thumb' aria-hidden='true' />
      <button
        type='button'
        aria-label={tableLabel}
        aria-pressed={mode === VIEW_MODE.TABLE}
        className={cn('view-toggle-button', { active: mode === VIEW_MODE.TABLE })}
        onClick={() => onChange(VIEW_MODE.TABLE)}
        data-tip={tableLabel}
        data-for={tooltipId}
        data-test={testIdPrefix ? `${testIdPrefix}-table` : undefined}
      >
        <TableViewIcon />
      </button>
      <button
        type='button'
        aria-label={detailLabel}
        aria-pressed={mode === VIEW_MODE.DETAIL}
        className={cn('view-toggle-button', { active: mode === VIEW_MODE.DETAIL })}
        onClick={() => onChange(VIEW_MODE.DETAIL)}
        data-tip={detailLabel}
        data-for={tooltipId}
        data-test={testIdPrefix ? `${testIdPrefix}-detail` : undefined}
      >
        <CardViewIcon />
      </button>
      <ReactTooltip
        id={tooltipId}
        textColor='black'
        backgroundColor='white'
        effect='solid'
        className='custom-tool-tip-component'
        padding='8px 6px'
        place='top'
        delayShow={200}
      />
    </div>
  )
}
